import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFoodBell: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="food-bell, serving-bell, glosche, serve"><path d="M2.75 18.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 19.25H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 15.75H21.25C21.25 2.5 2.75 2.5 2.75 15.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 4.75V5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFoodBell;
